module.exports = __webpack_public_path__ + "23_iclr.jpg?47892c9ec12c643df34941d322125d6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_iclr.jpg
// module id = 200
// module chunks = 0